<div class="pme-sticky-footer-wrapper" (mouseleave)="onMouseOut($event)">
  <pme-header></pme-header>
  

  <div class="pme-sticky-footer-content">
    <router-outlet (window:beforeunload)="doBeforeUnload($event)" (window:unload)="onUnload($event)"></router-outlet>
  </div>

  <pme-footer></pme-footer>
</div>
